"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../stitches.config");

var _themeMap = _interopRequireDefault(require("../../themes/themeMap"));

var StyledPage = (0, _stitches.styled)('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  '@desktop': {
    flexDirection: 'row'
  }
});
/**
 * The container for all elements on a page.
 */

var Page = function Page(_ref) {
  var _themeMap$theme;

  var children = _ref.children,
      theme = _ref.theme;
  return /*#__PURE__*/_react.default.createElement(StyledPage, {
    className: (_themeMap$theme = _themeMap.default[theme]) === null || _themeMap$theme === void 0 ? void 0 : _themeMap$theme.theme
  }, children);
};

Page.defaultProps = {
  theme: ''
};
var _default = Page;
exports.default = _default;